// 用户模块
import { defineStore } from 'pinia'
import { getUserInfo } from '@/api/user'
import { storageDict } from '@/config/dict'
import { dispatchCustomEvent } from '@/utils'
import { useMainStore } from '../index'
export const useUserStore = defineStore('user', {
  state: () => {
    return {
      /**
       * token
       */
      token: '',
      /**
       * 是否登录
       */
      isSign: ref(false),
      /**
       * 用户信息
       */
      userInfo: reactive({}),
      /**
       * 资产列表
       */
      asset: reactive([])
    }
  },
  actions: {
    /**
     * 设置 token
     * @param {*} token
     */
    setToken(token) {
      this.token = token || ''
      localStorage.setItem(storageDict.TOKEN, this.token)
    },
    /**
     * 设置 登录状态
     * @param {*} isSign
     */
    setIsSign(isSign) {
      this.isSign = isSign
    },
    /**
     * 退出登录
     */
    signOut() {
      let testPlatform = localStorage.getItem(storageDict.TEST_PLATFORM)
      localStorage.removeItem(storageDict.TOKEN)
      localStorage.removeItem(storageDict.USER_INFO)
      sessionStorage.clear()
      if (testPlatform) {
        localStorage.setItem(storageDict.TEST_PLATFORM, testPlatform)
      }
      this.$reset()
    },

    /**
     * 获取用户信息
     */
    async getUserInfo() {
      const res = await getUserInfo()
      if (res.code == 200) {
        Object.assign(this.userInfo, res.data || {})
        Object.assign(this.asset, this.userInfo.asset || [])
        dispatchCustomEvent('event_userInfoChange', this.userInfo)
        localStorage.setItem(storageDict.USER_INFO, JSON.stringify(this.userInfo))
        const mainStore = useMainStore()
        mainStore.getUserRechageNew()
        return this.userInfo
      } else {
        this.signOut()
      }
    }
  },
  // 开启数据持久化
  persist: true
})
